import {
  createRequestTypes,
  createActions,
} from 'app/store/actions/base-request.actions'

import {
  THEATER,
  SOUNDS,
  LIBRARY,
  BIBLIOTECA,
  SONIDOS,
  CAMINOS_BIBLIOTECA,
  ELAR,
  SLAR,
} from 'app/constants/teacher-guide.constants'

const TG_THEATER_ACTIONS = createRequestTypes('[Teacher Guide] Theater')
const TG_LIBRARY_ACTIONS = createRequestTypes('[Teacher Guide] Library')
const TG_BIBLIOTECA_ACTIONS = createRequestTypes('[Teacher Guide] Biblioteca')
const TG_SOUNDS_ACTIONS = createRequestTypes('[Teacher Guide] Sounds')
const TG_SONIDOS_ACTIONS = createRequestTypes('[Teacher Guide] Sonidos')
const TG_CAMINOS_BIBLIOTECA_ACTIONS = createRequestTypes(
  '[Teacher Guide] Caminos Biblioteca'
)
const TG_SLAR_BIBLIOTECA_ACTIONS = createRequestTypes(
  '[Teacher Guide] Slar Biblioteca'
)
const TG_ELAR_LIBRARY_ACTIONS = createRequestTypes(
  '[Teacher Guide] Elar Library'
)

const TGTheaterActionCreators = createActions(TG_THEATER_ACTIONS)
const TGLibraryActionCreators = createActions(TG_LIBRARY_ACTIONS)
const TGBibliotecaActionCreators = createActions(TG_BIBLIOTECA_ACTIONS)
const TGSoundsActionCreators = createActions(TG_SOUNDS_ACTIONS)
const TGSonidosActionCreators = createActions(TG_SONIDOS_ACTIONS)
const TGCaminosBibliotecaActionCreators = createActions(
  TG_CAMINOS_BIBLIOTECA_ACTIONS
)
const TGSlarBibliotecaActionCreators = createActions(TG_SLAR_BIBLIOTECA_ACTIONS)
const TGElarLibraryActionCreators = createActions(TG_ELAR_LIBRARY_ACTIONS)

export const TEACHER_GUIDE_ACTIONS = {
  [THEATER]: TG_THEATER_ACTIONS,
  [LIBRARY]: TG_LIBRARY_ACTIONS,
  [BIBLIOTECA]: TG_BIBLIOTECA_ACTIONS,
  [SOUNDS]: TG_SOUNDS_ACTIONS,
  [SONIDOS]: TG_SONIDOS_ACTIONS,
  [CAMINOS_BIBLIOTECA]: TG_CAMINOS_BIBLIOTECA_ACTIONS,
  [SLAR]: TG_SLAR_BIBLIOTECA_ACTIONS,
  [ELAR]: TG_ELAR_LIBRARY_ACTIONS,
}

export const TeacherGuideActionsCreators = {
  [THEATER]: TGTheaterActionCreators,
  [LIBRARY]: TGLibraryActionCreators,
  [BIBLIOTECA]: TGBibliotecaActionCreators,
  [SOUNDS]: TGSoundsActionCreators,
  [SONIDOS]: TGSonidosActionCreators,
  [CAMINOS_BIBLIOTECA]: TGCaminosBibliotecaActionCreators,
  [SLAR]: TGSlarBibliotecaActionCreators,
  [ELAR]: TGElarLibraryActionCreators,
}
